/**
 * Component: M48 Board
 * 
 */
'use strict';

export class Board
{
  constructor()
  {
    this.selectors = {
      component:    $('.c-v4-m48-board'),
      modal_class:  '.c-v4-m48-board--main-item-modal',
      prev:         $('.c-v4-m48-board--main-item-modal-footer-prev'),
      next:         $('.c-v4-m48-board--main-item-modal-footer-next')
    };
  }
  
  init()
  {
    if ( ! this.selectors.component.length ) return;

    let _self = this;

    $(_self.selectors.modal_class).on('hidden.bs.modal', () => {
      if ( $(_self.selectors.modal_class).hasClass('show') )
      {
        $('body').addClass('modal-open');
      }    
    });

    this.selectors.next.on('click', function( e )
    {
      e.preventDefault();

      let next = $(this)
        .closest( _self.selectors.modal_class )
        .nextAll( _self.selectors.modal_class )[0];
        
      let current = $(this).closest( _self.selectors.modal_class ).attr('id');

      $('#' + current).modal('hide');

      $(next).modal('show');
    });

    this.selectors.prev.on('click', function( e )
    {
      e.preventDefault();

      let prev = $(this)
        .closest( _self.selectors.modal_class )
        .prevAll( _self.selectors.modal_class )[0];
        
      let current = $(this).closest( _self.selectors.modal_class ).attr('id');

      $('#' + current).modal('hide');

      $(prev).modal('show');
    });
  }
}